"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreSelfStep = void 0;
const React = __importStar(require("react"));
const _1 = require(".");
const type_1 = require("../../../type");
const Field_AddStep_1 = require("../utils/Field.AddStep");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_DeleteStep_1 = require("../utils/Field.DeleteStep");
const Field_EditStep_1 = require("../utils/Field.EditStep");
const Field_SelfStepCreateArray_1 = __importDefault(require("../utils/Field.SelfStepCreateArray"));
const Field_Submit_1 = require("../utils/Field.Submit");
const CoreSelfStep = ({ props }) => {
    const [thisStep, setThisStep] = React.useState([props.fields]);
    const [keepData, setKeepData] = React.useState({});
    const [addData, setAddData] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);
    const [addIndex, setAddIndex] = React.useState(null);
    const [showZero, setShowZero] = React.useState(true);
    const [loadedZero, setLoadedZero] = React.useState(true);
    const [editData, setEditData] = React.useState(false);
    const [editIndex, setEditIndex] = React.useState(-1);
    React.useEffect(() => {
        (0, Field_SelfStepCreateArray_1.default)(props, setThisStep);
    }, [props.loadData]);
    React.useEffect(() => {
        if (deleteIndex >= 0) {
            (0, Field_DeleteStep_1.FunctionDeleteReferenceAfterDelete)(props, deleteIndex, setDeleteIndex);
        }
        else {
            return;
        }
    }, [deleteIndex]);
    React.useEffect(() => {
        if (addIndex !== null && addData) {
            (0, Field_AddStep_1.FieldDataToKeepThisStep)(props, setKeepData, addData, addIndex, setAddIndex);
        }
        else {
            return;
        }
    }, [addIndex]);
    React.useEffect(() => {
        if (editIndex !== null && editData) {
            (0, Field_EditStep_1.FieldDataToKeepThisEditStep)(props, editIndex, setKeepData, setEditIndex, editData);
        }
        else {
            return;
        }
    }, [editIndex]);
    React.useEffect(() => {
        var _a;
        const isLoadZero = (props === null || props === void 0 ? void 0 : props.loadData[(props === null || props === void 0 ? void 0 : props.parentKey) || (props === null || props === void 0 ? void 0 : props.grandParentKey)]) || {};
        const isRealZero = ((_a = Object.keys(isLoadZero)) === null || _a === void 0 ? void 0 : _a.length) === 0;
        if (loadedZero) {
            if (isRealZero) {
                setShowZero(props.renderIndexZero ? false : true);
            }
            if (props.renderIndexZero && isRealZero) {
                setThisStep([]);
            }
            setLoadedZero(false);
        }
        else {
            return;
        }
    }, [props.renderIndexZero]);
    React.useEffect(() => {
        if (thisStep.length === 0 && props.renderIndexZero) {
            setShowZero(false);
        }
    }, [thisStep]);
    const thisLoadData = keepData[props.grandParentKey || props.parentKey]
        ? keepData
        : props.loadData;
    const currentData = (0, Field_Submit_1.FunctionGetValueFromFieldReference)(props.originalFields, props.FieldReference);
    const FunctionAddStep = (data, index = -1) => {
        (0, Field_AddStep_1.FieldAddStep)(props, setThisStep, index);
        if (data) {
            setAddData(data);
            setAddIndex(index);
        }
    };
    const FunctionEditStep = (data, index = -1) => {
        (0, Field_EditStep_1.FieldEditStep)(props, setThisStep, index);
        if (data) {
            setEditData(data);
            setEditIndex(index);
        }
    };
    if (thisStep.length > 0 && thisLoadData && showZero) {
        return (React.createElement(React.Fragment, null, thisStep === null || thisStep === void 0 ? void 0 :
            thisStep.map((step, index) => {
                let element = (React.createElement(_1.FunctionCore, { validateDataNoChange: props === null || props === void 0 ? void 0 : props.validateDataNoChange, isStep: true, reset: props.reset, arrayCount: thisStep.length, showSymbol: props.showSymbol, isLastStep: thisStep.length === index + 1, isFirstStep: index === 0, initalValue: props === null || props === void 0 ? void 0 : props.initalValue, language: props.language, mode: props.mode, fields: step, parentKey: props.parentKey, key: `key-core-step-${props.parentKey}`, FieldReference: props.FieldReference, parentIndex: props.parentIndex, fieldIndex: index, loadData: thisLoadData, grandParentKey: props.grandParentKey, grandParentIndex: props.grandParentIndex, showError: props.showError, FunctionAddStep: (data) => {
                        FunctionAddStep(data, index);
                    }, currentData: currentData, FunctionRemoveStep: (callBackIndex = false) => {
                        (0, Field_DeleteStep_1.FieldDeleteStep)(props, callBackIndex !== false ? callBackIndex : index, setThisStep, setKeepData, setDeleteIndex);
                    }, FunctionEditStep: (data, callBackIndex = false) => {
                        FunctionEditStep(data, callBackIndex !== false ? callBackIndex : index);
                    } }));
                const thisProps = {
                    isFirstIndex: index === 0,
                    isLastIndex: thisStep.length === index + 1,
                    arrayCount: thisStep.length,
                    currentData: currentData,
                    selfIndex: index,
                };
                if (props === null || props === void 0 ? void 0 : props.coverChildrenComponent) {
                    return (React.createElement(React.Fragment, { key: `key-core-step-${props.parentKey}` }, props.coverChildrenComponent({
                        children: element,
                        childrenProps: thisProps,
                    })));
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        element,
                        index > 0 && props.showButtonRemove && (React.createElement("div", { onClick: () => {
                                (0, Field_DeleteStep_1.FieldDeleteStep)(props, index, setThisStep, setKeepData, setDeleteIndex);
                            }, className: `${Field_Constant_1.TEXT_AUTHOR}-remove ${props.classNameRemove ? props.classNameRemove : ""}` }, props.removeLabel
                            ? props.removeLabel
                            : Field_Constant_1.TEXT_DELETE_ARRAY[props.language]))));
                }
            }),
            props.showButtonAdd &&
                ((props === null || props === void 0 ? void 0 : props.limitArray) ? (props === null || props === void 0 ? void 0 : props.limitArray) > (thisStep === null || thisStep === void 0 ? void 0 : thisStep.length) : true) && (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-add ${typeof props.classNameAdd === type_1.TYPE_FUNCTION
                    ? props.classNameAdd(props)
                    : props.classNameAdd}`, onClick: () => {
                    FunctionAddStep();
                } }, props.addLabel ? props.addLabel : Field_Constant_1.TEXT_ADD_ARRAY[props.language]))));
    }
    else if (props.renderIndexZero && !showZero) {
        return (React.createElement(React.Fragment, null, props.renderIndexZero({
            add: (data) => {
                FunctionAddStep(data, -1);
                setShowZero(true);
            },
            isLast: true,
            isFirst: true,
        })));
    }
    else {
        return null;
    }
};
exports.CoreSelfStep = CoreSelfStep;
